import _defineProperty from "/github/workspace/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _breakpoints;

import defaultPalette from './palette.js';
import * as index from './icons/index.js';
var spaceUnit = 16;
var fontSize = 18;
var fontFamily = "neue-haas-grotesk-display";
var FontWeight;

(function (FontWeight) {
  FontWeight[FontWeight["REGULAR"] = 400] = "REGULAR";
  FontWeight[FontWeight["MEDIUM"] = 500] = "MEDIUM";
  FontWeight[FontWeight["BOLD"] = 700] = "BOLD";
  FontWeight[FontWeight["BOLDER"] = 900] = "BOLDER";
})(FontWeight || (FontWeight = {}));

var EBreakpoints = {
  MOBILE1: "mobile-1",
  MOBILE2: "mobile-2",
  TABLET1: "tablet-1"
};
var theme = {
  mode: "light",
  name: "default_theme",
  colors: defaultPalette,
  fontFamily: fontFamily,
  fontSize: fontSize,
  fonts: {},
  icons: index,
  spaceUnit: {
    xxs: "".concat(spaceUnit * 0.25, "px"),
    xs: "".concat(spaceUnit * 0.5, "px"),
    sm: "".concat(spaceUnit * 0.75, "px"),
    md: "".concat(spaceUnit, "px"),
    lg: "".concat(spaceUnit * 1.5, "px"),
    xl: "".concat(spaceUnit * 2, "px"),
    xxl: "".concat(spaceUnit * 3, "px"),
    xxxl: "".concat(spaceUnit * 4, "px")
  },
  spacing: {
    squishsm: {
      top: "".concat(spaceUnit / 4, "px"),
      left: "".concat(spaceUnit / 1.3, "px")
    },
    squishmd: {
      top: "".concat(spaceUnit / 2, "px"),
      left: "".concat(spaceUnit, "px")
    },
    squishlg: {
      top: "".concat(spaceUnit, "px"),
      left: "".concat(spaceUnit * 2, "px")
    },
    stretchsm: {
      left: "".concat(spaceUnit / 4, "px"),
      top: "".concat(spaceUnit / 1.3, "px")
    },
    stretchmd: {
      left: "".concat(spaceUnit / 2, "px"),
      top: "".concat(spaceUnit, "px")
    },
    stretchlg: {
      left: "".concat(spaceUnit, "px"),
      top: "".concat(spaceUnit * 2, "px")
    }
  },
  typography: {
    header: {
      h1bold: {
        fontSize: "80px",
        fontWeight: FontWeight.BOLD,
        lineHeight: "96px",
        fontFamily: fontFamily
      },
      h1roman: {
        fontSize: "80px",
        fontWeight: FontWeight.REGULAR,
        lineHeight: "92px",
        fontFamily: "neue-haas-grotesk-text"
      }
    },
    title: {
      title1bold: {
        fontSize: "64px",
        lineHeight: "77px",
        fontWeight: FontWeight.BOLD,
        fontFamily: fontFamily
      },
      title1light: {
        fontSize: "64px",
        lineHeight: "77px",
        fontWeight: FontWeight.REGULAR,
        fontFamily: fontFamily
      },
      title2bold: {
        fontSize: "48px",
        fontWeight: FontWeight.BOLD,
        lineHeight: "58px",
        fontFamily: fontFamily
      },
      title2medium: {
        fontSize: "48px",
        fontWeight: FontWeight.MEDIUM,
        lineHeight: "57px",
        fontFamily: fontFamily
      },
      title2light: {
        fontSize: "48px",
        fontWeight: FontWeight.REGULAR,
        lineHeight: "54px",
        fontFamily: fontFamily
      },
      title3bold: {
        fontSize: "40px",
        fontWeight: FontWeight.BOLD,
        lineHeight: "48px",
        fontFamily: fontFamily
      },
      title3medium: {
        fontSize: "40px",
        fontWeight: FontWeight.MEDIUM,
        lineHeight: "48px",
        fontFamily: fontFamily
      },
      title3light: {
        fontSize: "40px",
        fontWeight: FontWeight.REGULAR,
        lineHeight: "48px",
        fontFamily: fontFamily
      }
    },
    body: {
      body1bold: {
        fontSize: "32px",
        fontWeight: FontWeight.BOLD,
        lineHeight: "38px",
        fontFamily: fontFamily
      },
      body1light: {
        fontSize: "32px",
        fontWeight: FontWeight.REGULAR,
        lineHeight: "36px",
        fontFamily: fontFamily
      },
      body2bold: {
        fontSize: "24px",
        fontWeight: FontWeight.BOLD,
        lineHeight: "29px",
        fontFamily: fontFamily
      },
      body2light: {
        fontSize: "24px",
        fontWeight: FontWeight.REGULAR,
        lineHeight: "29px",
        fontFamily: fontFamily
      }
    },
    text: {
      text1bold: {
        fontSize: "18px",
        fontWeight: FontWeight.BOLD,
        lineHeight: "23px",
        fontFamily: fontFamily
      },
      text1light: {
        fontSize: "18px",
        fontWeight: FontWeight.REGULAR,
        lineHeight: "22px",
        fontFamily: fontFamily
      },
      text2bold: {
        fontSize: "16px",
        fontWeight: FontWeight.BOLD,
        lineHeight: "20px",
        fontFamily: fontFamily
      },
      text2roman: {
        fontSize: "16px",
        fontWeight: FontWeight.REGULAR,
        lineHeight: "20px",
        fontFamily: "neue-haas-grotesk-text"
      },
      text2romanunderline: {
        fontSize: "16px",
        fontWeight: FontWeight.REGULAR,
        lineHeight: "20px",
        textDecoration: "underline",
        fontFamily: "neue-haas-grotesk-text"
      },
      text3bold: {
        fontSize: "14px",
        fontWeight: FontWeight.BOLD,
        lineHeight: "18px",
        fontFamily: fontFamily
      },
      text3light: {
        fontSize: "14px",
        fontWeight: FontWeight.REGULAR,
        lineHeight: "17px",
        fontFamily: fontFamily
      },
      text4bold: {
        fontSize: "12px",
        fontWeight: FontWeight.BOLD,
        lineHeight: "15px",
        fontFamily: fontFamily
      },
      text4light: {
        fontSize: "12px",
        fontWeight: FontWeight.REGULAR,
        lineHeight: "15px",
        fontFamily: fontFamily
      }
    }
  },
  breakpoints: (_breakpoints = {}, _defineProperty(_breakpoints, EBreakpoints.MOBILE1, 700), _defineProperty(_breakpoints, EBreakpoints.MOBILE2, 900), _defineProperty(_breakpoints, EBreakpoints.TABLET1, 1140), _breakpoints)
};
export { EBreakpoints, FontWeight, theme as default, spaceUnit };